/**
 * Labstep
 *
 * @module screens/PurchaseOrder/Index
 * @desc PurchaseOrder index
 */

import { PurchaseOrderActionCreate } from 'labstep-web/components/PurchaseOrder/Action/Create';
import { PurchaseOrderEmptyState } from 'labstep-web/components/PurchaseOrder/EmptyState';
import { PurchaseOrderListOrTable } from 'labstep-web/components/PurchaseOrder/ListOrTable';
import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import { MasterIndex } from 'labstep-web/screens/Master/Index';
import { PurchaseOrderIndexBreadcrumb } from 'labstep-web/screens/PurchaseOrder/Index/Breadcrumb';
import { PurchaseOrderIndexLeftPane } from 'labstep-web/screens/PurchaseOrder/Index/LeftPane';
import type React from 'react';
import { useMemo } from 'react';
import { bulkActions, filters } from './constants';
import type { IScreensPurchaseOrderIndexProps } from './types';

export const ScreensPurchaseOrderIndex: React.FC<
  IScreensPurchaseOrderIndexProps
> = ({ group, links }) => {
  const breadcrumb = useMemo(
    () => <PurchaseOrderIndexBreadcrumb />,
    [],
  );
  const leftPane = useMemo(
    () => <PurchaseOrderIndexLeftPane links={links} />,
    [links],
  );
  const params = useMemo(
    () => ({
      group_id: group.id,
    }),
    [group.id],
  );
  const noResultsMessage = useMemo(
    () => <PurchaseOrderEmptyState />,
    [],
  );
  const action = useMemo(() => <PurchaseOrderActionCreate />, []);
  return (
    <MasterIndex
      breadcrumb={breadcrumb}
      leftPane={leftPane}
      params={params}
      noResultsMessage={noResultsMessage}
      entityName={PurchaseOrder.entityName}
      action={action}
      bulkActions={bulkActions}
      filters={filters}
    >
      {({
        entities,
        ...rest
      }: {
        entities: PurchaseOrder[];
      }): React.ReactElement => (
        <PurchaseOrderListOrTable
          purchaseOrders={entities}
          {...rest}
        />
      )}
    </MasterIndex>
  );
};
